import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { artistHomeMessages as messages } from './artistHomeMessages';
import { CatalogCounts } from './catalogSummary';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Releases, missing links and releases with no smartlink. A count above zero that needs work is red. */
const CatalogCountsTrioComponent: React.FC<{ counts: CatalogCounts }> = ({ counts }) => {
  const intl = useIntl();
  const stats = [
    { key: 'releases', value: counts.releases, label: messages.catalogReleases, isWarn: false },
    {
      key: 'missing',
      value: counts.missingLinks,
      label: messages.catalogMissingLinks,
      isWarn: counts.missingLinks > 0,
    },
    { key: 'noLink', value: counts.noSmartlink, label: messages.catalogNoSmartlink, isWarn: counts.noSmartlink > 0 },
  ];

  return (
    <div className={styles.trio}>
      {stats.map((stat) => (
        <div key={stat.key} className={styles.stat}>
          <span className={clsx(styles.statValue, stat.isWarn && styles.statWarn)}>
            {intl.formatNumber(stat.value)}
          </span>
          <small>{intl.formatMessage(stat.label)}</small>
        </div>
      ))}
    </div>
  );
};

export const CatalogCountsTrio = TypedMemo(CatalogCountsTrioComponent);
